module.exports = {
    colorData: () => {
        return[
            {
                "Apache RR 310": {
                    "Colors": [
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"ROJO NEGRO",
                            "hexa":"#c50100",
                            "hexaAlt":"#000000",
                        }
                    ]
                },
                "Sport 100 ELS": {
                    "Colors": [
                        {
                            "name":"AZUL PETROLEO GRIS",
                            "hexa":"#18273d",
                            "hexaAlt":"#6d6d6d",
                        },
                        {
                            "name":"GRIS",
                            "hexa":"#c6d6d6d",
                            "hexaAlt":"#545454",
                        },
                        {
                            "name":"NEGRO GRIS",
                            "hexa":"#000000",
                            "hexaAlt":"#6d6d6d",
                        },
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"ROJO",
                            "hexa":"#c50100",
                            "hexaAlt":"#e23737",
                        }
                    ]
                },
                "Sport 100 KLS": {
                    "Colors": [
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"NEGRO VERDE",
                            "hexa":"#000000",
                            "hexaAlt":"#9cb51b",
                        }
                    ]
                },
                "Stryker": {
                    "Colors": [
                        {
                            "name":"NEGRO AZUL",
                            "hexa":"#000000",
                            "hexaAlt":"#0c4692",
                        },
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"NEGRO VERDE",
                            "hexa":"#000000",
                            "hexaAlt":"#9cb51b",
                        }
                    ]
                },
                "Max 125": {
                    "Colors": [
                        {
                            "name":"NEGRO AZUL",
                            "hexa":"#066fb2",
                            "hexaAlt":"#000000",
                        },
                        {
                            "name":"NEGRO GRIS",
                            "hexa":"#000000",
                            "hexaAlt":"#6d6d6d",
                        },
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        }
                    ]
                },
                "Apache 160 2V": {
                    "Colors": [
                        {
                            "name":"NEGRO",
                            "hexa":"#000000",
                            "hexaAlt":"#6d6d6d",
                        },
                        {
                            "name":"GRIS",
                            "hexa":"#6d6d6d",
                            "hexaAlt":"#c50100",
                        }
                    ]
                },
                "Apache 160 4V": {
                    "Colors": [
                        {
                            "name":"GRIS AZUL",
                            "hexa":"#000000",
                            "hexaAlt":"#066fb2",
                        },
                        {
                            "name":"GRIS NEGRO",
                            "hexa":"#6d6d6d",
                            "hexaAlt":"#000000",
                        },
                        {
                            "name":"GRIS ROJO",
                            "hexa":"#6d6d6d",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"ROJO NEGRO",
                            "hexa":"#c50100",
                            "hexaAlt":"#000000",
                        }
                    ]
                },
                "Apache 180 2V": {
                    "Colors": [
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        }
                    ]
                },
                "Apache 200 2V": {
                    "Colors": [
                        {
                            "name":"NEGRO",
                            "hexa":"#000000",
                            "hexaAlt":"#3d3d3d",
                        },
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        }
                    ]
                },
                "Apache 200 fi": {
                    "Colors": [
                        {
                            "name":"AZUL NEGRO",
                            "hexa":"#066fb2",
                            "hexaAlt":"#3d3d3d",
                        },
                        {
                            "name":"ROJO NEGRO",
                            "hexa":"#c50100",
                            "hexaAlt":"#3d3d3d",
                        }
                    ]
                },
                "Raider 125": {
                    "Colors": [
                        {
                            "name":"AMARILLO",
                            "hexa":"#D6B93C",
                            "hexaAlt":"#efcf48",
                        },
                        {
                            "name":"AZUL",
                            "hexa":"#0c4692",
                            "hexaAlt":"#2776cc",
                        },
                        {
                            "name":"NEGRO",
                            "hexa":"#000000",
                            "hexaAlt":"#3d3d3d",
                        },
                        {
                            "name":"ROJO",
                            "hexa":"#c50100",
                            "hexaAlt":"#3d3d3d",
                        }
                    ]
                },
                "Ntorq 125": {
                    "Colors": [
                        {
                            "name":"AZUL BLANCO NEGRO",
                            "hexa":"#0c4692",
                            "hexaAlt":"#EAEAEA",
                        },
                        {
                            "name":"BLANCO ROJO NEGRO",
                            "hexa":"#eaeaea",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"NEGRO AMARILLO",
                            "hexa":"#000000",
                            "hexaAlt":"#dbdc00",
                        },
                        {
                            "name":"NEGRO GRIS",
                            "hexa":"#000000",
                            "hexaAlt":"#6d6d6d",
                        },
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        }
                    ]
                },
                "Ntorq 125 Racing": {
                    "Colors": [
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        }
                    ]
                },
                "Ntorq 125 fi": {
                    "Colors": [
                        {
                            "name":"NEGRO VERDE",
                            "hexa":"#000000",
                            "hexaAlt":"#9cb51b",
                        }
                    ]
                },
                "Neo NX 110": {
                    "Colors": [
                        {
                            "name":"GRIS AZUL",
                            "hexa":"#6d6d6d",
                            "hexaAlt":"#066fb2",
                        },
                        {
                            "name":"NEGRO ROJO",
                            "hexa":"#000000",
                            "hexaAlt":"#c50100",
                        },
                        {
                            "name":"NEGRO VERDE",
                            "hexa":"#000000",
                            "hexaAlt":"#9cb51b",
                        }
                    ]
                },
                "Motocarro King Basico": {
                    "Colors": [
                        {
                            "name":"BLANCO ROJO NEGRO",
                            "hexa":"#eaeaea",
                            "hexaAlt":"#000000",
                        }
                    ]
                },
                "Motocarro King Carpa Especial": {
                    "Colors": [
                        {
                            "name":"BLANCO ROJO NEGRO",
                            "hexa":"#eaeaea",
                            "hexaAlt":"#000000",
                        }
                    ]
                },
                "Motocarro King Carpa Full": {
                    "Colors": [
                        {
                            "name":"BLANCO ROJO NEGRO",
                            "hexa":"#eaeaea",
                            "hexaAlt":"#000000",
                        }
                    ]
                }
            }
        ]
    }
}